import * as React from 'react';
import ToggleSwitch from "../common/input/ToggleSwitch";
import { VIDEOVISIT_LABEL } from "../../constants/textConstants";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import BackdropWrapper from '../common/BackdropWrapper';

export default class FindCareResultsHeading extends React.Component {
    constructor(props) {
        super(props);
    }    

    onFiltersClear() {
        const { onFiltersClear } = this.props;
        if (onFiltersClear) {
            onFiltersClear();
        }
    }

    onFilterRemove(filter) {
        const { onFilterRemove } = this.props;
        if (onFilterRemove) {
            onFilterRemove(filter);
        }
    }

    onFeaturedFilterChange(checked) {
        const { onFilterSet, updateVideoToolTipPreference, shouldShowVideoToolTip } = this.props;
        let activityCode = checked ? "MBHWeb.UI.FindCare.VideoVisit.Toggled" : "MBHWeb.UI.FindCare.VideoVisit.Untoggled";
        logUI(activityCode, new Date(), Tools.getURLPath());
        if (onFilterSet)
            onFilterSet(['visitType'], [checked ? "Video Visit" : -1]);
        if (updateVideoToolTipPreference && shouldShowVideoToolTip)
            updateVideoToolTipPreference();
    }

    render() {

        const { isDisabled, listName, resultsCount, toggleFilters, toggleView, shouldShowVideoToolTip, updateVideoToolTipPreference, searchRunning, filtersList, selectedFiltersList, selectedFiltersCount} = this.props;
        const noResults = resultsCount === 0;
        const isDisabledFilter = noResults || isDisabled;
        let showFeaturedTooltip = shouldShowVideoToolTip && window && window.innerWidth >= 480 && !searchRunning;
        const videoVisitChecked = filtersList.visitType && filtersList.visitType.value !== -1 && (typeof filtersList.visitType.value === 'string' && filtersList.visitType.value.toLowerCase() === "video visit");
        const videoToggleMarkup = (
            <BackdropWrapper
                toolTipContainerClass="video-visit-tool-tip-container"
                onClickBackdrop={updateVideoToolTipPreference}
                toolTipInfo="A new service is available! Turn on this filter to view doctors who offer Video Visits."
                okBtnText="GOT IT!"
                showTooltip={showFeaturedTooltip}
                wrapperClass={"filter-featured" + (isDisabledFilter && !videoVisitChecked ? " disabled-style" : "") + (showFeaturedTooltip ? " filter-tooltip-enabled" : "")}
            >
                <ToggleSwitch
                    name="videoVisitFilter"
                    placeholder="Video Visit"
                    icon="svg-video-visit"
                    checked={videoVisitChecked}
                    disabled={isDisabledFilter && !videoVisitChecked}
                    onChange={checked => this.onFeaturedFilterChange(checked)}
                />
            </BackdropWrapper>);
        return (
            <div id={listName}>
                <div className="row mobile-filter__btn">
                    <div className="col-6">
                        <div className={"filter-btn" + (isDisabledFilter ? " disabled-style" : "")} disabled={isDisabledFilter} onClick={toggleFilters}>
                            <div className="filter-text">
                                <span className="icon-filter" />
                                <span className="filter-label">{`Filters (${selectedFiltersCount})`}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="toggle-view-btn">
                            <div className="map-view-btn" onClick={() => toggleView(false)}>
                                <span className="icon-map" /><span className="view-label">Map View</span>
                            </div>
                            <div className="list-view-btn" onClick={() => toggleView(true)}>
                                <span className="icon-list-view" /><span className="view-label">List View</span>
                            </div>
                        </div>
                    </div>
                    {listName !== "Locations" &&  <div className="col-12">{videoToggleMarkup}</div>}
                </div>
                <div className="row mobile-filter__header">
                    <div className="col-12">
                        <div className="filter-close-btn" onClick={toggleFilters}>
                            <span className="icon-close" />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="filter-text">
                            <span className="filter-label">{`Filters (${selectedFiltersCount})`}</span>
                        </div>
                    </div>
                </div>
                <div className="row mobile-filter__match">
                    <div className={listName !== "Locations" ? "col-6" : "col-12"}>{`${listName} Matched: ${resultsCount}`}</div>
                    {listName !== "Locations" && <div className="col-6">{videoToggleMarkup}</div>}
                </div>
                <div className="row filters-selected">
                    <div className="col-12">               
                        {listName !== "Locations" && videoToggleMarkup}                            
                        <div className={"filter-btn" + (isDisabledFilter ? " disabled-style" : "")} disabled={isDisabledFilter} onClick={toggleFilters}>
                            <div className="filter-text">
                                <span className="icon-filter" />
                                <span className="filter-label">{`Filters (${selectedFiltersCount})`}</span>
                            </div>
                        </div>
                        {selectedFiltersList && selectedFiltersList.length > 0 &&
                            <ul className="saved-filters-list">
                            {selectedFiltersCount > 0 && selectedFiltersList.map((item, index) =>
                                item.display && (typeof (item.display) !== "string" || (typeof (item.display) === "string" && item.display.toLowerCase() !== VIDEOVISIT_LABEL)) && <li className="saved-filters" key={index}>
                                        <span className="filter-name">{item.display}</span>
                                        <span className="remove-term" onClick={() => this.onFilterRemove(item)}>
                                            <span className="icon-close" />
                                        </span>
                                    </li>
                                )}
                                <li className="clear-btn">
                                    <span onClick={() => this.onFiltersClear()}>Clear All</span>
                                </li>
                            </ul>
                        }
                    </div>
                </div>
            </div>
        );
    }
}